enum SearchOrigin {
    Start = 'Starts',
    End = 'Ends',
}

export default SearchOrigin;
